export const HEADER_FOOTER_CONTENT_TYPE = 'blog_settings'
